import type {
  ProfileByIdServiceConfig,
  ProfileChangelogServiceConfig,
  ProfileListServiceConfig,
} from '@/services/httpServices/ProfileServices/types';

import { createQueryKey } from './queryKeyUtils';

export function profileListKeys(params?: ProfileListServiceConfig) {
  return createQueryKey(['profiles', 'list'], params);
}

/**
 * Creates a unique query key for infinite profile list queries
 * Includes 'infinite' prefix to differentiate from regular list queries
 */
export function infiniteProfileListKeys(params?: ProfileListServiceConfig) {
  return ['infinite', ...profileListKeys(params)];
}

export function profileByIdKeys(params?: ProfileByIdServiceConfig) {
  return createQueryKey(['profiles', 'single'], params);
}

export function profileChangelogKeys(params?: ProfileChangelogServiceConfig) {
  return createQueryKey(['profiles', 'changelog'], params);
}
